import { render, staticRenderFns } from "./AnalisisTable.vue?vue&type=template&id=2dea1c3e&"
import script from "./AnalisisTable.vue?vue&type=script&lang=js&"
export * from "./AnalisisTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports